import React, { createContext, useContext, useState, useCallback } from "react";
import { apiInstance } from "../api/api";

const CompanyContext = createContext();

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
    const [companyInfo, setCompanyInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchCompanyInfo = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const response = await apiInstance.get('/company-info/');
            setCompanyInfo(response.data);
        } catch (error) {
            console.error("Error fetching company info:", error);
            setError('Unable to load company information. Check that a company profile exists.');
        } finally {
            setLoading(false);
        }
    }, []);

    const updateCompanyInfo = useCallback(async (updatedInfo) => {
        try {
            // const response = await apiInstance.put('/company-info/', updatedInfo);
             const response = await apiInstance.put('/company-info/update-info/', updatedInfo);
             // console.log("API response after update:", response.data);
            setCompanyInfo(response.data);
        } catch (error) {
            console.error('Error updating company info:', error);
            throw error;
        }
    }, []);

    return (
        <CompanyContext.Provider value={{ companyInfo, loading, error, fetchCompanyInfo, updateCompanyInfo }}>
            {children}
        </CompanyContext.Provider>
    );
};

